import React from "react";
import about2 from "../../assets/img/about-4.jpg";
import about3 from "../../assets/img/about-5.jpg";

function ReferralBonus() {
  return (
    <div class="container-xxl py-6">
      <div class="container">
        <div class="row g-5">
          <div class="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
            <div
              class="position-relative overflow-hidden ps-5 pt-5 h-100"
              style={{ minHeight: "400px" }}
            >
              <img
                class="position-absolute w-100 h-100"
                src={about3}
                alt=""
                style={{ objectFit: "cover" }}
              />
              <img
                class="position-absolute top-0 start-0 bg-white pe-3 pb-3"
                src={about2}
                alt=""
                style={{ width: "200px", height: "200px" }}
              />
            </div>
          </div>
          <div class="col-lg-6 wow fadeInUp" data-wow-delay="0.5s">
            <div class="h-100">
              <h6 class="text-primary text-uppercase mb-2">Referral Bonus</h6>
           
              <p>
              Revtech invites you to participate in our referral program. We
                understand that high-quality employees like you often know other
                talented people who may wish to work with Revtech. To qualify
                for this referral fee, refer your friend that we do not have in
                our database for a consulting or full time position. Make sure
                that when the individual calls us they should mention your name
                or if you want to call us, then we'll take it from there.
              </p>
              
            
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReferralBonus;
